import React from 'react';
// used for making the prop types of this component
import PropTypes from 'prop-types';

// core components
import Button from 'Common/CustomButtons/Button.jsx';
import { FormattedMessage } from 'react-intl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel/InputLabel';
import RequiredMark from 'Common/Form/RequiredMark';

class FileUpload extends React.Component {
    /**
     * @type {Object}
     */
    static propTypes = {
        input: PropTypes.object,
        meta: PropTypes.object,
        accept: PropTypes.string,
        label: PropTypes.string,
        withLabel: PropTypes.bool,
        required: PropTypes.bool,
        id: PropTypes.string,
        sample: PropTypes.any,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            file: null,
            fileName: null,
            accept: props.accept ? props.accept : ''
        };
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    get placeholder() {
        return <FormattedMessage id={ `field.${this.props.placeholder}.placeholder` }/>;
    }

    handleImageChange(e) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            this.setState({
                file: file,
                fileName: file.name,
            });
        };
        reader.readAsDataURL(file);
        const { input: { onChange } } = this.props;
        onChange(e.target.files[0]);
    }

    handleSubmit(e) {
        e.preventDefault();
        // this.state.file is the file uploaded
        // in this function you can save the file (this.state.file) on form submit
        // you have to call it yourself
    }

    handleClick() {
        var input = document.createElement('input');
        input.type = 'file';
        input.name = 'attach';
        input.accept = this.state.accept;
        input.onchange = this.handleImageChange;
        input.click();
    }

    handleRemove() {
        const { input: { onChange } } = this.props;
        this.setState({
            file: null,
            fileName: null,
        });
        onChange(null);
    }

    render() {
        const {
            meta: { touched, error },
            withLabel,
            label,
            required,
            id,
            sample
        } = this.props;

        let message = error,
            placeholders = {};

        if (Array.isArray(message)) {
            [message, placeholders] = message;
        }

        let errorMessage = /validation.error.\w+/.test(message)
            ? this.context.intl.formatMessage({ id: message }, placeholders)
            : message;

        return (
            <div className="fileinput text-center">
                {withLabel && (
                    <InputLabel htmlFor={id} error={error && touched}>
                        <FormattedMessage id={`field.${label}.label`} />
                        {required ? <RequiredMark /> : ''}
                    </InputLabel>
                )}

                <div className="attach-field-wrapper">
                    <div className={ 'thumbnail' }>
                        { this.state.fileName }
                    </div>
                    { sample }
                    <div>
                        { this.state.file === null ? (
                            <Button
                                round
                                color="rose"
                                onClick={ () => this.handleClick() }
                            >
                                { 'Select file' }
                            </Button>
                        ) : (
                            <span>
                                <Button
                                    round
                                    color="rose"
                                    onClick={ () => this.handleClick() }
                                >
                                  Change
                                </Button>
                                <Button
                                    color="danger"
                                    round
                                    onClick={ () => this.handleRemove() }
                                >
                                    <i className="fa fa-times"/> Remove
                                </Button>
                            </span>
                        ) }
                    </div>
                    { touched && error &&
                    <FormHelperText className="errors-list">
                        { errorMessage }
                    </FormHelperText> }
                </div>
            </div>
        );
    }
}

FileUpload.propTypes = {
    placeholder: PropTypes.string,
};

export default FileUpload;



// WEBPACK FOOTER //
// ./src/common/CustomUpload/FileUpload.jsx